<div class="page-wrapper">


  <div id="mobilereportstable">
    <div class="row justify-content-center p-3" >
      <!-- <div class="col">
        <div class="click-instruction mobile">
          <img src="assets/images/app_images/smartreport.svg" alt="cursor clicking on highlighted terms in a report">
          <p>Click this icon (available near your CT, MRI, PET CT, and Ultrasound reports) to view your customized 'Radiology Smart Report'. An Interactive page will explain the report in a simple language and diagrams. </p>
        </div>
      </div> -->
    </div>
  </div>

  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <!-- Row -->
    <!-- Column -->
    <div class="row" *ngFor="let item of PatientVists">
      <div class="col-md-12 col-lg-2 col-sm-12 col-xs-12">
        <div class="card customcard">
          <button id="showdate" type="button" class="btn custom-button text-dark"><i
              class="fas fa-calendar-alt text-center" style="position: relative;
                left: -5px;"></i>{{ item.visits[0].Sid_Date_Formatted }}</button>
        </div>
      </div>
      <div class="col-lg-12 col-xlg-12 col-md-12 col-xs-12 col-sm-12" *ngFor="let visit of item.visits">
        <div class="card" style="border: none;">
          <div class="card-body">
            <div>
              <div class="d-lg-flex" id="desktopreportstable">
                <div class="" style="width:15%;margin-top: 9px;">
                  <h6 class="card-subtitle" style="position: relative;top: 15px;">{{ visit.PName }}
                  </h6>
                </div>
                <div class="mobbtnspace"><a href="javascript:void(0)" class="link">
                    <button class="btn btn-success mx-auto mx-md-0 text-white"
                      (click)="PrintAllDocuments(visit.Sid_No,visit.Sid_Date)">Download All Reports<span>
                        {{ visit.downloadAll }}
                      </span></button></a>
                </div>
                <div class="ml-auto mobbtnspace">
                  <h4 class="card-title mt-2"><button class="btn mx-auto mx-md-0 text-white text-capitalize" [ngStyle]="{
                          'background-color':
                          visit.BillingStatus === 'Due' ? '#F62D51' : '#55CE63'
                        }" style="margin: 0px;">Billing status :&nbsp;<span>{{ visit.BillingStatus
                        }}</span></button></h4>
                </div>
              </div>
              <div id="desktopreportstable" class="d-flex px-2">
                <!-- <div id="desktopreportstable" class="p-1">
                    <h6 class="font-normal"><span id="font-bold" class="text-muted" style="color: #90A4AE;font-size: 18px;">DOB:&nbsp;</span>{{ visit.Dob }}
                    </h6>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp; -->
                <!-- Mobile number need not be shown in the screen - by Dr. Arun -->
                <!-- <div id="desktopreportstable" class="p-1">
                    <h6 class="font-normal"><span id="font-bold" class="text-muted" style="color: #90A4AE;font-size: 18px;">Phone Number:&nbsp;</span>{{ visit.Mobile }}
                    </h6>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp; -->
                <div id="desktopreportstable" class="p-1">
                  <h6 class="font-normal"><span id="font-bold" class="text-muted"
                      style="color: #90A4AE;font-size: 18px;">Visit&nbsp;No:&nbsp;</span>{{
                    visit.Sid_No }}</h6>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;
                <div id="desktopreportstable" class="p-1">
                  <h6 class="font-normal"><span id="font-bold" class="text-muted"
                      style="color: #90A4AE;font-size: 18px;">Referred&nbsp;By:&nbsp;</span>{{
                    visit.Ref_Name }}</h6>
                </div>
              </div>
            </div>
            <!--DESTOP VIEWER-->
            <div id="desktopreportstable">
              <div id="customhoverrow" class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 text-info hide-mobile">
                  <h5 id="testnamelabel" class="font-normal">Test Name</h5>
                </div>
                <div class="col-md-3 col-lg-3 col-xs-6 text-info">
                  <h5 id="testnamelabel" class="font-normal">Films</h5>
                </div>
                <div class="col-md-3 col-lg-3 col-xs-6 text-info">
                  <h5 id="testnamelabel" class="font-normal">Reports</h5>
                </div>
              </div>
              <div *ngFor="let visittest of visit.tests">
                <div *ngIf="visittest.Test_Name != ''" id="customhoverrow" class="row pt-3 pb-3">
                  <div id="mobspacing" class="col-lg-6 col-md-6 col-sm-12">
                    <small class="text-dark text-uppercase">{{ visittest.Test_Name }}</small>
                  </div>
                  <div class="col-md-3 col-lg-3 col-xs-6">
                    <!--Flim Status Pending-->
                    <span id="iconshover" class="me-3 text-success" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Not Applicable'" style="width: 170px;float: left;cursor: pointer;"> {{
                      visittest.Test_Film_Status
                      }}</span>

                    <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Pending'" style="width: 170px;float: left;cursor: pointer;"> {{ visittest.Test_Film_Status
                      }}</span>

                    <span id="iconshover" class="me-3 text-success" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Completed'" style="width: 170px;float: left;cursor: pointer;"> {{ visittest.Test_Film_Status
                      }}</span>

                    <span id="iconshover" class="me-3 text-warning" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Partially Completed'" style="width: 170px;float: left;cursor: pointer;"> {{
                      visittest.Test_Film_Status
                      }}</span>

                    <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Cancelled'" style="width: 170px;float: left;cursor: pointer;"> {{ visittest.Test_Film_Status
                      }}</span>
                    <!--Flims (View)-->
                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name != 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnableFilmPrint == 'Y' &&
                                                visittest.Test_Film_Status == 'Completed'
                                              " aria-hidden="true" (click)="
                                                ViewDownloadRadiologyReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Code,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  'view',
                                                  'films',
                                                  '1'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>



                    <!--Flims (Download)-->
                    <!-- <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.EnableFilmPrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                    <!-- <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.IsManualCollection == 'Y' &&
                                                visittest.Test_Film_Status == 'Pending'
                                               " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)"
                          id="type-info" style="cursor:pointer"></i> -->

                    <i id="iconshovertext" title="View" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.IsManualCollection == 'Y' &&
                                                visittest.Test_Film_Status == 'Completed'
                                               " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)"
                      id="type-info" style="cursor:pointer"></i>

                    <!-- manual collection icon show -->

                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.Test_Name != 'Lab' &&
                        visittest.IsManualCollection == 'N' &&
                        visittest.EnableFilmPrint == 'Y' &&
                        visittest.Test_Film_Status == 'Completed'
                       " (click)="
                        ViewDownloadRadiologyReport(
                          visit.accesstoken,
                          visit.BranchCode,
                          visit.Sid_No,
                          visit.Sid_Date,
                          visittest.Test_Code,
                          visittest.Test_Name,
                          visit.PName,
                          visit.Sid_Date_Formatted,
                          'download',
                          'films',
                          '1'
                        )" id="type-info" style="cursor:pointer"></i>



                    <!-- <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                       visittest.EnableFilmPrint == 'N' &&
                       visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                    <!-- <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Film_Status == 'Pending'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Film_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                      style="cursor:pointer"></i>
                  </div>



                  <!-- <td class="align-middle"> -->
                  <div class="col-md-3 col-lg-3 col-xs-6">
                    <!--Report Status Start-->
                    <span id="iconshovertext" class="me-3 text-warning" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Partially Completed'
                         " style="width: 170px;float: left;cursor: pointer;">{{
                      visittest.Test_Report_Status }}</span>

                    <span id="iconshovertext" class="me-3 text-success" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Completed'
                         " style="width: 170px;float: left;cursor: pointer;">{{ visittest.Test_Report_Status }}</span>


                    <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Pending'" style="width: 170px;float: left;cursor: pointer;"> {{ visittest.Test_Report_Status
                      }}</span>

                    <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Cancelled'" style="width: 170px;float: left;cursor: pointer;"> {{
                      visittest.Test_Report_Status
                      }}</span>
                    <!--End Report Status-->
                    <!--Completed-->
                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name == 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnablePrint == 'Y'&&
                                                visittest.Test_Report_Status ==
                                                'Completed'
                                              " (click)="
                                                ViewDownloadLabReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  visit.No_Report_header_footer,
                                                  '1',
                                                  visittest.Test_Report_Status,
                                                  'view'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>

                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                          visittest.Test_Name != 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Completed'
                        " aria-hidden="true" (click)="
                          ViewDownloadRadiologyReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Code,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            'view',
                            'report',
                            '1'
                          )
                        " id="type-info" style="cursor:pointer"></i>
                    <!--Partially Completed-->
                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name == 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnablePrint == 'Y'&&
                                                visittest.Test_Report_Status ==
                                                'Partially Completed'
                                              " (click)="
                                                ViewDownloadLabReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  visit.No_Report_header_footer,
                                                  '1',
                                                  visittest.Test_Report_Status,
                                                  'view'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>

                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                          visittest.Test_Name != 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Partially Completed'
                        " aria-hidden="true" (click)="
                          ViewDownloadRadiologyReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Code,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            'view',
                            'report',
                            '1'
                          )
                        " id="type-info" style="cursor:pointer"></i>
                    <!-- <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.EnablePrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>  -->

                    <!-- manual collection icon show -->

                    <!-- <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Pending'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                    <!--Completed Show error-->
                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                      style="cursor:pointer"></i>
                    <!--Partially Completed Show error-->
                    <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Partially Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                      style="cursor:pointer"></i>
                    <!--Completed Download-->
                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                          visittest.Test_Name == 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Completed'
                        " (click)="
                          ViewDownloadLabReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            visit.No_Report_header_footer,
                            '1',
                            visittest.Test_Report_Status,
                            'download'
                          )
                        " id="type-info" style="cursor:pointer"></i>



                    <!-- <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.EnablePrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>

                        <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                          visittest.IsManualCollection == 'Y' &&
                          visittest.Test_Report_Status == 'Pending'
                        " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                      style="cursor:pointer"></i>

                    <i id="iconshover" title="Download" id="type-info" class="me-3 fas fa-download" aria-hidden="true"
                      *ngIf="
                        visittest.Test_Name != 'Lab' &&
                        visittest.IsManualCollection == 'N' &&
                        visittest.EnablePrint == 'Y' &&  visittest.Test_Report_Status ==
                        'Completed'" (click)="
                        ViewDownloadRadiologyReport(
                          visit.accesstoken,
                          visit.BranchCode,
                          visit.Sid_No,
                          visit.Sid_Date,
                          visittest.Test_Code,
                          visittest.Test_Name,
                          visit.PName,
                          visit.Sid_Date_Formatted,
                          'download',
                          'report',
                          '1'
                        )
                       " style="cursor:pointer"></i>



                    <!--Partially Completed-->
                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                       visittest.Test_Name == 'Lab' &&
                       visittest.IsManualCollection == 'N' &&
                       visittest.EnablePrint == 'Y' &&
                       visittest.Test_Report_Status ==
                       'Partially Completed'
                     " (click)="
                       ViewDownloadLabReport(
                        visit.accesstoken,
                         visit.BranchCode,
                         visit.Sid_No,
                         visit.Sid_Date,
                         visittest.Test_Name,
                         visit.PName,
                         visit.Sid_Date_Formatted,
                         visit.No_Report_header_footer,
                         '1',
                         visittest.Test_Report_Status,
                         'download'
                       )
                     " id="type-info" style="cursor:pointer"></i>
                    <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                     visittest.IsManualCollection == 'Y' &&
                     visittest.Test_Report_Status == 'Partially Completed'
                    " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                      style="cursor:pointer"></i>



                    <i id="iconshover" title="Download" id="type-info" class="me-3 fas fa-download" aria-hidden="true"
                      *ngIf="
                     visittest.Test_Name != 'Lab' &&
                     visittest.IsManualCollection == 'N' &&
                     visittest.EnablePrint == 'Y' &&  visittest.Test_Report_Status ==
                     'Partially Completed'" (click)="
                     ViewDownloadRadiologyReport(
                      visit.accesstoken,
                       visit.BranchCode,
                       visit.Sid_No,
                       visit.Sid_Date,
                       visittest.Test_Code,
                       visittest.Test_Name,
                       visit.PName,
                       visit.Sid_Date_Formatted,
                       'download',
                       'report',
                       '1'
                     )
                    " style="cursor:pointer"></i>

                    <!-- <img id="iconshover" style="cursor:pointer"  class="me-3 icon-advanced accessionnumber" title="Smart Report" src="assets/images/app_images/smartreport.svg"  alt="Smart Report" 
                    aria-hidden="true" *ngIf="
                    getsmartreportvalidation(visittest.Dept_Code) && 
                    visittest.Test_Report_Status == 'Completed' 
                   " aria-hidden="true" (click)="getsmartreport(
                    visit.BranchCode,
                    visit.Sid_No,
                    visit.Sid_Date,
                    visittest.Test_Code,
                    visittest.Test_Name,
                    visit.PName,
                    visit.Sid_Date_Formatted,
                    'getsmartreport',
                    'getsmartreport',
                    '1'
                   )"
                    > -->
                    <!-- <i id="iconshover" title="Smart Report" class="me-3 icon-advanced  accessionnumber"
                      aria-hidden="true" *ngIf="
                    getsmartreportvalidation(visittest.Test_Name) && 
                    visittest.Test_Report_Status == 'Completed' 
                   " aria-hidden="true" (click)="getsmartreport(
                    visit.BranchCode,
                    visit.Sid_No,
                    visit.Sid_Date,
                    visittest.Test_Code,
                    visittest.Test_Name,
                    visit.PName,
                    visit.Sid_Date_Formatted,
                    'getsmartreport',
                    'getsmartreport',
                    '1'
                   )" id="type-info" style="cursor:pointer"></i> -->

                  </div>
                </div>
                <div *ngIf="visittest.Test_Name == ''">
                  <div colspan="3" align="center">
                    No Records Found...
                  </div>
                </div>
                <div *ngIf="!visit.tests?.length">
                  <div colspan="3">No Records Found...</div>
                </div>
              </div>
            </div>
            <!---------===========================================================================================================================================================
=======================================================================================================================================================================-->
            <!--MOBILE VIEWER-->
            <div id="mobilereportstable" class="d-lg-flex">
              <div class="" id="mobilereportstable">
                <h6 class="card-subtitle" style="position: relative;top: 15px;left:12px">{{ visit.PName }}
                </h6>
              </div>
              <div id="mobilereportstable" class="mobbtnspace"><a href="javascript:void(0)" class="link">
                  <button class="btn btn-success mx-auto mx-md-0 text-white mt-3"
                    (click)="PrintAllDocuments(visit.Sid_No,visit.Sid_Date)"
                    style="position: relative;left: 3%;">Download All Reports<span>
                      {{ visit.downloadAll }}
                    </span></button></a>
              </div>
              <div id="mobilereportstable" class="ml-auto mobbtnspace">
                <h4 class="card-title mt-2"><button class="btn mx-auto mx-md-0 text-white text-capitalize" [ngStyle]="{
                      'background-color':
                      visit.BillingStatus === 'Due' ? '#F62D51' : '#55CE63'
                    }" style="position: relative;left: 3%;">Billing status :&nbsp;<span>{{ visit.BillingStatus
                      }}</span></button></h4>
              </div>
            </div>
            <div id="mobilereportstable" class="d-flex col-sm-12">
              <div id="mobilereportstable" class="p-1 col-sm-3">
                <h6 class="font-normal" style="font-size: 14px;"><span id="font-bold" class="text-muted"
                    style="color: #90A4AE;">DOB:<br></span>{{ visit.Dob }}
                </h6>
              </div>
              <!-- <div id="mobilereportstable" class="p-1 col-sm-3">
                  <h6 class="font-normal" style="font-size: 14px;"><span id="font-bold" class="text-muted" style="color: #90A4AE;">Mobile:<br></span>{{ visit.Mobile }}
                  </h6> 
                </div> -->
              <div id="mobilereportstable" class="p-1 col-sm-4">
                <h6 class="font-normal" style="font-size: 14px;"><span id="font-bold" class="text-muted"
                    style="color: #90A4AE;">Visit&nbsp;No:<br></span>{{
                  visit.Sid_No }}</h6>
              </div>
              <div id="mobilereportstable" class="p-1 col-sm-5">
                <h6 class="font-normal" style="font-size: 14px;"><span id="font-bold" class="text-muted"
                    style="color: #90A4AE;">Referred<br>By:<br></span>{{
                  visit.Ref_Name }}</h6>
              </div>
            </div>
            <div id="mobilereportstable">
              <div id="customhoverrow" class="row">
                <div *ngFor="let visittest of visit.tests">
                  <div *ngIf="visittest.Test_Name != ''" id="customhoverrow" class="row pt-3 pb-3">
                    <div id="mobspacing" class="col-lg-6 col-md-6 col-sm-12">
                      <small id="testnamevalue" class="text-dark text-uppercase" style="font-weight: bold;">{{
                        visittest.Test_Name }}</small>
                    </div>
                    <div class="col-md-3 col-lg-3 col-sm-4 text-muted pl-4">
                      <h5 id="testnamelabel" class="font-normal"
                        style="font-weight: bold;position: relative;top: -4px;letter-spacing: 1px;">Films</h5>
                    </div>
                    <div class="col-md-3 col-lg-3 col-sm-8">
                      <!--Flim Status Pending-->
                      <span id="iconshover" class="me-3 text-success mt-1" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Not Applicable'" style="float: left;cursor: pointer;position: relative;top: -2px;"> {{
                        visittest.Test_Film_Status
                        }}</span>

                      <span id="iconshover" class="me-3 text-danger mt-1" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Pending'" style="float: left;cursor: pointer;position: relative;top: -2px;"> {{
                        visittest.Test_Film_Status
                        }}</span>

                      <span id="iconshover" class="me-3 text-success mt-1" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Completed'" style="float: left;cursor: pointer;position: relative;top: -2px;"> {{
                        visittest.Test_Film_Status
                        }}</span>

                      <span id="iconshover" class="me-3 text-warning mt-1" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Partially Completed'" style="float: left;cursor: pointer;position: relative;top: -2px;"> {{
                        visittest.Test_Film_Status
                        }}</span>

                      <span id="iconshover" class="me-3 text-danger mt-1" aria-hidden="true" *ngIf="
                        visittest.Test_Film_Status ==
                        'Cancelled'" style="float: left;cursor: pointer;position: relative;top: -2px;"> {{
                        visittest.Test_Film_Status
                        }}</span>
                      <!--Flims (View)-->
                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name != 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnableFilmPrint == 'Y' &&
                                                visittest.Test_Film_Status == 'Completed'
                                              " aria-hidden="true" (click)="
                                                ViewDownloadRadiologyReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Code,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  'view',
                                                  'films',
                                                  '1'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>



                      <!--Flims (Download)-->
                      <!-- <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.EnableFilmPrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>

                        <i id="iconshover" title="Hide" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.IsManualCollection == 'Y' &&
                                                visittest.Test_Film_Status == 'Pending'
                                               " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)"
                          id="type-info" style="cursor:pointer"></i> -->

                      <i id="iconshovertext" title="View" class="me-3 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.IsManualCollection == 'Y' &&
                                                visittest.Test_Film_Status == 'Completed'
                                               " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)"
                        id="type-info" style="cursor:pointer"></i>
                      <!-- manual collection icon show -->

                      <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.Test_Name != 'Lab' &&
                        visittest.IsManualCollection == 'N' &&
                        visittest.EnableFilmPrint == 'Y' &&
                        visittest.Test_Film_Status == 'Completed'
                       " (click)="
                        ViewDownloadRadiologyReport(
                          visit.accesstoken,
                          visit.BranchCode,
                          visit.Sid_No,
                          visit.Sid_Date,
                          visittest.Test_Code,
                          visittest.Test_Name,
                          visit.PName,
                          visit.Sid_Date_Formatted,
                          'download',
                          'films',
                          '1'
                        )" id="type-info" style="cursor:pointer"></i>






                      <!-- <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                       visittest.EnableFilmPrint == 'N' &&
                       visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>

                        <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Film_Status == 'Pending'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                      <i id="iconshover" title="Download" class="me-3 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Film_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                        style="cursor:pointer"></i>
                    </div>

                    <!-- <td class="align-middle"> -->
                    <div class="col-md-3 col-lg-3 col-sm-4 text-muted pl-4"><span id="testnamelabel" class="font-normal"
                        style="font-weight: bold;position: relative;top: -3px;">Reports</span></div>
                    <div class="col-md-3 col-lg-3 col-sm-8">
                      <!--Report Status Start-->
                      <span id="iconshover" class="me-3 text-warning" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Partially Completed'
                         ">{{
                        visittest.Test_Report_Status }}</span>

                      <span id="iconshover" class="me-3 text-success" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Completed'
                         ">{{ visittest.Test_Report_Status }}</span>


                      <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Pending'"> {{ visittest.Test_Report_Status
                        }}</span>

                      <span id="iconshover" class="me-3 text-danger" aria-hidden="true" *ngIf="
                          visittest.Test_Report_Status ==
                          'Cancelled'"> {{ visittest.Test_Report_Status
                        }}</span>
                      <!--End Report Status-->
                      <!--Completed view -->
                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name == 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnablePrint == 'Y' &&
                                                visittest.Test_Report_Status ==
                                                'Completed'
                                              " (click)="
                                                ViewDownloadLabReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  visit.No_Report_header_footer,
                                                  '1',
                                                  visittest.Test_Report_Status,
                                                  'view'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>

                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                          visittest.Test_Name != 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Completed'
                        " aria-hidden="true" (click)="
                          ViewDownloadRadiologyReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Code,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            'view',
                            'report',
                            '1'
                          )
                        " id="type-info" style="cursor:pointer"></i>
                      <!--Partially Completed View-->
                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                                                visittest.Test_Name == 'Lab' &&
                                                visittest.IsManualCollection == 'N' &&
                                                visittest.EnablePrint == 'Y' &&
                                                visittest.Test_Report_Status ==
                                                'Partially Completed'
                                              " (click)="
                                                ViewDownloadLabReport(
                                                  visit.accesstoken,
                                                  visit.BranchCode,
                                                  visit.Sid_No,
                                                  visit.Sid_Date,
                                                  visittest.Test_Name,
                                                  visit.PName,
                                                  visit.Sid_Date_Formatted,
                                                  visit.No_Report_header_footer,
                                                  '1',
                                                  visittest.Test_Report_Status,
                                                  'view'
                                                )
                                              " id="type-info" style="cursor:pointer"></i>

                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                          visittest.Test_Name != 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Partially Completed'
                        " aria-hidden="true" (click)="
                          ViewDownloadRadiologyReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Code,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            'view',
                            'report',
                            '1'
                          )
                        " id="type-info" style="cursor:pointer"></i>
                      <!-- <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.EnablePrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>  -->

                      <!-- manual collection icon show -->

                      <!-- <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Pending'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                      <!--Partially Completed-->
                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                          visittest.IsManualCollection == 'Y' &&
                          visittest.Test_Report_Status == 'Partially Completed'
                        " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                        style="cursor:pointer"></i>
                      <!--Completed View-->
                      <i id="iconshover" title="Hide" class="me-2 fas fa-eye" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                        style="cursor:pointer"></i>


                      <!--Completed Download-->
                      <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                          visittest.Test_Name == 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Completed'
                        " (click)="
                          ViewDownloadLabReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            visit.No_Report_header_footer,
                            '1',
                            visittest.Test_Report_Status,
                            'download'
                          )
                        " id="type-info" style="cursor:pointer"></i>



                      <!-- <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.EnablePrint == 'N' &&
                        visittest.IsManualCollection == 'N'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i>

                        <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                          visittest.IsManualCollection == 'Y' &&
                          visittest.Test_Report_Status == 'Pending'
                        " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                          style="cursor:pointer"></i> -->

                      <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Completed'
                       " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                        style="cursor:pointer"></i>
                      <!--Partially Completed-->
                      <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                        visittest.IsManualCollection == 'Y' &&
                        visittest.Test_Report_Status == 'Partially Completed'
                        " aria-hidden="true" (click)="ShowErrorMessage(visittest.ErrorMsg)" id="type-info"
                        style="cursor:pointer"></i>

                      <i id="iconshover" title="Download" id="type-info" class="me-2 fas fa-download" aria-hidden="true"
                        *ngIf="
                        visittest.Test_Name != 'Lab' &&
                        visittest.IsManualCollection == 'N' &&
                        visittest.EnablePrint == 'Y' &&
                        visittest.Test_Report_Status ==
                        'Completed'" (click)="
                        ViewDownloadRadiologyReport(
                          visit.accesstoken,
                          visit.BranchCode,
                          visit.Sid_No,
                          visit.Sid_Date,
                          visittest.Test_Code,
                          visittest.Test_Name,
                          visit.PName,
                          visit.Sid_Date_Formatted,
                          'download',
                          'report',
                          '1'
                        )
                       " style="cursor:pointer"></i>
                      <!--Partially Completed Download-->
                      <i id="iconshover" title="Download" class="me-2 fas fa-download" aria-hidden="true" *ngIf="
                          visittest.Test_Name == 'Lab' &&
                          visittest.IsManualCollection == 'N' &&
                          visittest.EnablePrint == 'Y' &&
                          visittest.Test_Report_Status ==
                          'Partially Completed'
                        " (click)="
                          ViewDownloadLabReport(
                            visit.accesstoken,
                            visit.BranchCode,
                            visit.Sid_No,
                            visit.Sid_Date,
                            visittest.Test_Name,
                            visit.PName,
                            visit.Sid_Date_Formatted,
                            visit.No_Report_header_footer,
                            '1',
                            visittest.Test_Report_Status,
                            'download'
                          )
                        " id="type-info" style="cursor:pointer"></i>
                      <i id="iconshover" title="Download" id="type-info" class="me-2 fas fa-download" aria-hidden="true"
                        *ngIf="
                        visittest.Test_Name != 'Lab' &&
                        visittest.IsManualCollection == 'N' &&
                        visittest.EnablePrint == 'Y' &&
                        visittest.Test_Report_Status ==
                        'Partially Completed'" (click)="
                        ViewDownloadRadiologyReport(
                          visit.accesstoken,
                          visit.BranchCode,
                          visit.Sid_No,
                          visit.Sid_Date,
                          visittest.Test_Code,
                          visittest.Test_Name,
                          visit.PName,
                          visit.Sid_Date_Formatted,
                          'download',
                          'report',
                          '1'
                        )
                       " style="cursor:pointer"></i>


                       <!-- <img id="iconshover" style="cursor:pointer"  class="me-3 icon-advanced accessionnumber" title="Smart Report" src="assets/images/app_images/smartreport.svg"  alt="Smart Report" 
                       aria-hidden="true" *ngIf="
                       getsmartreportvalidation(visittest.Dept_Code) && 
                       visittest.Test_Report_Status == 'Completed' 
                      " aria-hidden="true" (click)="getsmartreport(
                       visit.BranchCode,
                       visit.Sid_No,
                       visit.Sid_Date,
                       visittest.Test_Code,
                       visittest.Test_Name,
                       visit.PName,
                       visit.Sid_Date_Formatted,
                       'getsmartreport',
                       'getsmartreport',
                       '1'
                      )"
                       > -->

                    </div>
                  </div>
                  <div *ngIf="visittest.Test_Name == ''">
                    <div colspan="3" align="center">
                      No Records Found...
                    </div>
                  </div>
                  <div *ngIf="!visit.tests?.length">
                    <div colspan="3">No Records Found...</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Column -->
      <!-- Column -->
      <!-- Column -->
    </div>
    <!-- Row -->
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
  </div>
  <div id="pageoverlay" class="pageoverlay ajaxOverlay"></div>
  <div id="pagespinner" class="pagespinner ajaxOverlay"></div>